var styles = {"fontElementMap":"HTx5n","orderedlist":"UKN6-","bulletedlist":"mUE6b","listItem":"bH-u4"};

export { styles as s };
//# sourceMappingURL=lists-3e9f87b4.js.map
